export default {
  "content": "<path d=\"M.5 44c0-24.3 19.7-44 44-44s44 19.7 44 44-19.7 44-44 44S.5 68.3.5 44z\" fill=\"#000\" fill-opacity=\".05\"/><path d=\"M50.5 30v4h-8v8h-4v-4h-12v20h36V30h-12zm-16 24h-4V42h4v12zm8 0h-4v-8h4v8zm8 0h-4V38h4v16zm8 0h-4V34h4v20z\" fill=\"#000\" fill-opacity=\".3\"/>",
  "attrs": {
    "width": "89",
    "height": "88",
    "viewBox": "0 0 89 88",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};